import { Component, OnInit, Renderer2, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter, delay, timeout } from 'rxjs/operators'; 
import { Observable, of } from 'rxjs';
import { Globals } from './services/globals';
import { LockService } from './services/lock.service';
import { UserService } from './services/user.service';
import { ActiveToast, ToastService } from "ng-uikit-pro-standard";
import { TeamService } from './services/team.service';
import { ContactService } from './services/contactService';
import Echo from "laravel-echo"
import { DataService } from './services/data.service';
import { EcoDocsTitleService } from './services/ecodocs-title.service';
import moment from 'moment';
import { getSpecialPages } from './helpers/utils';

@Component({
  selector: 'mdb-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']

})

export class AppComponent implements OnInit, AfterViewInit {
  values: string[] = ['Tag 1', 'Tag 2', 'Tag 4'];
  specialPage: boolean;
  // used to delcalre array of events to be tracked
  renderEvents;
  
  isLockScreenReady: boolean = false;

  private specialPages: string[];

  private currentUrl = '';

  trialDaysLeft: number = null;

  constructor(
    private router: Router,
    private _globals: Globals,
    private location: Location,
    public userService: UserService,
    public lockService: LockService,
    private ecodocsTitleService: EcoDocsTitleService,
  ) {
    this.specialPages = getSpecialPages();

    this.userService.currentUser.subscribe(user => {
      if (user) {
        (window as any).Echo = new Echo({
          broadcaster: 'pusher',
          key: user.pusher_key,
          authEndpoint: this._globals.api_base_url + '/broadcasting/auth',
          auth: {
            headers: {
              Authorization: "Bearer " + this.userService.access_token,
              Accept: "application/json",
            },
          }
        });
        (window as any).Echo.private(`${user.company_id}`).listen('RefreshCurrentUser', (e) => {
          this.userService.getCurrent().subscribe();
        });
      }
    });
    
    this.userService.currentUser.subscribe(user => {
      if (user && user.subscription_status){
        if (!user.subscription_status.is_subscribed && user.subscription_status.trial_active) {
          this.trialDaysLeft = moment(user.subscription_status.trial_ends_at).diff(moment(), 'day');
        } else {
          this.trialDaysLeft = null;
        }
      } else {
        this.trialDaysLeft = null;
      }
    });

    // user should be updated with each refresh (for permissions, ... etc)
    this.userService.getCurrent().subscribe();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((route:any) => {
      this.currentUrl = route.url;
      
      this.specialPage = false;
      this.specialPages.forEach((v, i) => {
        if (this.currentUrl.startsWith(v)) {
          this.specialPage = true;
        }
      });

      if (this.currentUrl.startsWith('/wopi/')) {
        document.body.classList.add('office_body_required_styles');
      } else {
        document.body.classList.remove('office_body_required_styles');
      }
      
      this.isLockScreenReady = true;
    });
  }

  ngOnInit(): void {
    // restore favicon in case it had been changed
    this.ecodocsTitleService.setFavIconLink();
  }
  ngAfterViewInit() {
    
  }
  goBack(): void {
    this.location.back();
  }

  onBillingPages() {
    return document.location.pathname == '/billing' || document.location.pathname == '/billing-succeeded';
  }
  

}
